/**
 * Main JavaScript Entry Point
 *
 * This file is the main entry point for all frontend JavaScript.
 */

import { initGSAP, ScrollTrigger } from './gsap/init';
import { initAnimations } from './animations';
import { initComponents } from './components';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initGSAP();
  initAnimations();
  initComponents();
});

// Initialize GSAP ScrollTrigger on load
window.addEventListener('load', () => {
  // Refresh ScrollTrigger after all content is loaded
  if (ScrollTrigger) {
    ScrollTrigger.refresh();
  }
});
